var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"returnGoods"},[(_vm.IS_GROUP)?_c('div',{staticClass:"switch"},[_c('span',{on:{"click":function($event){return _vm.onSitch()}}},[_vm._v(" "+_vm._s(_vm.switchText)+" ")])]):_vm._e(),_vm._v(" "),_c('OmsTable',{attrs:{"jordan-table-config":_vm.returnDetailAddTable.table}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }